import { type RevisionPageComputed, RevisionPageType } from '../types';
import { randomUUID } from '../utils';

/**
 * Create a page computed.
 */
export function createPageComputed(
    parts: Pick<RevisionPageComputed, 'title' | 'computed'> & Partial<RevisionPageComputed>
): RevisionPageComputed {
    return {
        ...parts,
        type: RevisionPageType.Computed,
        id: parts.id ?? randomUUID(),
        edits: parts.edits ?? {},
    };
}
